// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media screen and (max-width: 1800px) {
  .Grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .Grid {
    grid-template-columns: auto;
  }
}
@media screen and (max-width: 576px) {
  .Grid {
    grid-template-columns: auto;
  }
}

.tip_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media screen and (max-width: 1800px) {
  .tip_grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .tip_grid {
    grid-template-columns: auto;
    display: block;
  }
}
@media screen and (max-width: 576px) {
  .tip_grid {
    grid-template-columns: auto;
    display: block;
  }
}

@media screen and (max-width: 700px) {
  .main_width {
    width: fit-content;
  }
}
@media screen and (min-width: 991px) and (max-width: 1231px) {
  .main_width {
    display: grid;
  }
}

.__normal_btn {
  color: #999999;
}

.__color_btn {
  background-color: #FFEE20 !important;
  border-color: #FFEE20 !important;
  color: #1E1E1E !important;
}

@media screen and (min-width: 992px) and (max-width: 1042px) {
  .control-pane {
    width: 440px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LifetimeCount/index.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;AACJ;AAAI;EAHJ;IAIQ,8BAAA;EAGN;AACF;AADI;EAPJ;IAQQ,2BAAA;EAIN;AACF;AAFI;EAXJ;IAYQ,2BAAA;EAKN;AACF;;AAHA;EACQ,aAAA;EACI,8BAAA;AAMZ;AAJY;EAJZ;IAKgB,8BAAA;EAOd;AACF;AALY;EARZ;IASgB,2BAAA;IACA,cAAA;EAQd;AACF;AANY;EAbZ;IAcgB,2BAAA;IACA,cAAA;EASd;AACF;;AALI;EADJ;IAEQ,kBAAA;EASN;AACF;AAPQ;EALR;IAMY,aAAA;EAUV;AACF;;AARA;EACI,cAAA;AAWJ;;AATA;EACI,oCAAA;EACA,gCAAA;EACA,yBAAA;AAYJ;;AATI;EADJ;IAEY,YAAA;EAaV;AACF","sourcesContent":[".Grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr ;\n    @media screen and (max-width:1800px) {\n        grid-template-columns: 1fr 1fr;\n    }\n    \n    @media only screen and (min-width: 576px) and (max-width: 992px) {\n        grid-template-columns: auto;\n    }\n    \n    @media screen and (max-width:576px) {\n        grid-template-columns: auto;\n    }\n }\n.tip_grid{\n        display: grid;\n            grid-template-columns: 1fr 1fr;\n        \n            @media screen and (max-width:1800px) {\n                grid-template-columns: 1fr 1fr;\n            }\n        \n            @media only screen and (min-width: 576px) and (max-width: 992px) {\n                grid-template-columns: auto;\n                display: block;\n            }\n        \n            @media screen and (max-width:576px) {\n                grid-template-columns: auto;\n                display: block;\n            }\n    }\n\n.main_width{\n    @media screen and (max-width:700px) {\n        width: fit-content;\n        }\n\n        @media screen and (min-width:991px) and (max-width:1231px){\n            display: grid;\n        }\n}\n.__normal_btn {\n    color: #999999;\n}\n.__color_btn {\n    background-color: #FFEE20 !important;\n    border-color: #FFEE20 !important;\n    color: #1E1E1E !important;\n}\n.control-pane{\n    @media screen and (min-width:992px) and (max-width:1042px) {\n            width: 440px;\n        }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
